<template>
  <div class="row">
    <div class="col-12">
      <form>
        <category-tree
          v-for="child in categories"
          :key="child.name"
          :category="child"
        >
        </category-tree>
      </form>
    </div>
  </div>
</template>

<script>
import CategoryTree from './Forms/CategoryTree.vue'

export default {
  name: 'VNFRProductFormsCategories',
  props: {
    categories: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    'loadingData'( newValue ) {
      if ( newValue === true ) {
        this.$emit( 'loading', true )
      } else {
        this.$emit( 'loading', false )
      }
    }
  },
  data() {
    return {}
  },
  components: {
    CategoryTree
  }
}
</script>
